import React from 'react'
import { useState } from 'react'
import styles from './AppLayout.module.css'

import Header from '../components/common/Header/Header'
import Sidebar from '../components/common/sidebar/Sidebar'
import { Outlet } from 'react-router-dom'
import IdleSessionPopup from '../components/dashboard/applications/IdleSessionPopup'
import useIdleSession from '../hooks/useIdleSession'

const AppLayout = () => {

    const {
            timeLeft,
            warningOpen,
            warningTimeLeft,
            handleExtendSession,
            handleSessionTimeout,
        } = useIdleSession();

    return (
        <div className={styles['app-layout']}>
            <Header />
            <div className={styles['app-body']}>
                <Sidebar />
                <main className={styles['main-content']}>
                    <Outlet />
                </main>
                <IdleSessionPopup
                    isOpen={warningOpen}
                    timeLeft={warningTimeLeft}
                    onExtendSession={handleExtendSession}
                    onLogout={handleSessionTimeout}
                />
            </div>
        </div>
    )
}

export default AppLayout